import { useQuery } from "@tanstack/vue-query";
import { computed, Ref, toValue } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteSectionQueryKeys } from "@/data/api/v4b/site-section/site-section-query-keys";
import { SiteSectionId, V4HSiteId } from "@/data/common/ids";

export function useGetSectionIsDeletableQuery(siteId: Ref<V4HSiteId>, sectionId: Ref<SiteSectionId | undefined>) {
  const v4bClientSdk = useServices().v4b.clientSdk;

  const _sectionId = computed(() => sectionId.value!);
  const _enabled = computed(() => !!sectionId.value);

  return useQuery({
    queryKey: SiteSectionQueryKeys.isDeletable(siteId, _sectionId),
    queryFn: () => {
      if (!_sectionId.value) {
        throw new Error("Subscription ID is required");
      }

      return v4bClientSdk.siteSection.isDeletable(toValue(_sectionId));
    },
    enabled: _enabled,
  });
}
